import type { ExtendsOfElementBase } from "@/canvasController/types";
import type { DocumentViewerWidget } from "@/elements/documentViewer";

export function checkIsDocumentViewer(obj: ExtendsOfElementBase): obj is DocumentViewerWidget {
    return obj?.constructorName === "documentViewer";
}
